import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FileUploadDialogComponent } from '../../../../../../announcement/admin/create/add-file-modal/add-file-modal.component';
import { CaseService } from '../../../../../services/case.services';
import { AppMessageService } from '../../../../../../../shared/services/app-message/app-message.service';
import { AppAlertService } from '../../../../../../../shared/services/app-alert/app-alert.service';
import {
  CaseDocumentSavedTypeEnum,
  ICaseDocument,
} from '../../../../../interfaces/interfaces';
import saveAs from 'file-saver';
import { TranslateService } from '@ngx-translate/core';
import { FileApiService } from '../../../../../../../shared/services/file-api/file-api.service';
import { AuthService } from '../../../../../../../shared/services/auth/auth.service';

@Component({
  selector: 'app-case-documents',
  templateUrl: './case-documents.component.html',
  styleUrl: './case-documents.component.scss',
})
export class CaseDocumentsComponent {
  @ViewChild('fileUploadDialog') fileUploadDialog: FileUploadDialogComponent;

  @Output() closeOn=new EventEmitter();
  openPopup: boolean = false;
  caseId: number | null = null;
  token: string;
  mode:'edit'|'readonly'='edit'
  constructor(
    private readonly caseService: CaseService,
    private readonly messageService: AppMessageService,
    private readonly alertService: AppAlertService,
    private readonly translateService: TranslateService,
    private readonly fileService: FileApiService,
    private readonly authService: AuthService
  ) {
    this.token = this.authService.getToken() ?? '';
  }

  activeTab: 'ambulance' | 'user' | 'patient'|'labmed' | null = null;

  documents: ICaseDocument[] = [];

  filteredDocuments: ICaseDocument[] = [];

  setActiveTab(tab: 'ambulance' | 'user' | 'patient'|'labmed' | null) {
    if (this.activeTab === tab || tab === null) {
      this.activeTab = null;
      this.filteredDocuments = [...this.documents];
      return;
    }
    this.activeTab = tab;
    this.filteredDocuments = this.documents.filter(
      (e) => e.savedType === this.activeTab
    );
  }

  initilize(caseId: number | null,activeTab:'ambulance' | 'user' | 'patient' | null=null,mode:'edit'|'readonly'='edit') {
    this.openPopup = true;
    this.caseId = caseId;
    this.mode=mode;
    this.caseService.getDocuments(this.caseId!, {}).subscribe({
      next: (res) => {
        if (res.success) {
          this.documents = Array.isArray(res.documents)
            ? res.documents.map((e) => {
              let createdBy: string;

              if (e.savedType === CaseDocumentSavedTypeEnum.PATIENT) {
                createdBy = this.translateService.instant('case.document.patient');
              } else if (e.createdBy?.firstName && e.createdBy?.lastName) {
                createdBy = `${e.createdBy.firstName} ${e.createdBy.lastName}`;
              } else {
                createdBy = '-';
              }

              return {
                ...e,
                createdBy,
              };
            })
            : [];

          this.setActiveTab(activeTab);
        }
      },
    });
  }

  addDocument() {
    this.fileUploadDialog.initialize(null, []);
  }

  onSaveFile(e: any) {
    const formData = new FormData();
    if (this.caseId) {
      formData.append('file', e.file);
      formData.append('fileDescription', e.fileDescription);
      formData.append('caseId', this.caseId.toString());
      this.caseService.saveDocument(formData).subscribe({
        next: (res) => {
          if (res.success) {
            this.documents = [
              ...this.documents,
              {
                id: res.data.id,
                fileName: res.data.fileName,
                fileUrl: res.data.fileUrl,
                description: res.data.description,
                createdBy:
                  res?.data?.createdBy?.firstName &&
                  res?.data?.createdBy?.lastName
                    ? res.data.createdBy.firstName +
                      ' ' +
                      res.data.createdBy.lastName
                    : '-',
                createdAt: res.data.createdAt,
                savedType: res.data.savedType,
              },
            ];
            this.setActiveTab(this.activeTab);
            this.messageService.successToast(
              this.translateService.instant('common.success'),
              this.translateService.instant('case.document.success')
            );
          }
        },
      });
    }
  }

  deleteClick(row: ICaseDocument) {
    this.alertService.sweetConfirm({
      header: this.translateService.instant('case.document.delete-sure-header'),
      message: this.translateService.instant('case.document.delete-sure-text'),
      showCloseButton: true, 
      accept: () => this.deleteDocument(row),
    });
  }

  private deleteDocument(row: ICaseDocument) {
    this.caseService
      .deleteDocument({ caseId: this.caseId!, documentId: row.id! })
      .subscribe({
        next: (res) => {
          this.documents = this.documents.filter((e) => e.id !== row.id);
          this.setActiveTab(this.activeTab);
          this.messageService.successToast(
            this.translateService.instant('common.success'),
            this.translateService.instant('case.document.delete-success')
          );
        },
      });
  }
  download(doc: ICaseDocument) {
    this.fileService.getFileBlob(doc.fileUrl, this.token)
      .subscribe((blob) => {
        saveAs(blob, doc.fileName);
      });
  }
  clearAll() {
    this.documents = [];
    this.filteredDocuments = [];
    this.caseId = null;
    this.activeTab = null;
    this.closeOn.emit()
  }
}
